import { queryClient } from '@queries/client';
import { localSessionStore } from '@stores/local-session.store';
import { sidebarStore } from '@stores/sidebar.store';
import { surveySidebarStore } from '@stores/survey-sidebar.store';
import { removeSelectedCompanyId } from './company.util';

type ClearAppCacheParams = {
  isLogout?: boolean;
};

export const clearAppCache = ({ isLogout = false }: ClearAppCacheParams = {}) => {
  if (isLogout) {
    removeSelectedCompanyId();
    sidebarStore.persist.clearStorage();
    surveySidebarStore.persist.clearStorage();
    localSessionStore.persist.clearStorage();
  }

  try {
    queryClient.clear();
  } catch (error) {
    console.error('Error clearing query client', error);
  }
};
